import React, { Component } from 'react';
import {__} from "../Translator";

import './BookAppointment.css'
import Footer from "../components/Footer";
import Header from "../components/Header";
import StepIndicator from "../components/StepIndicator";
import Actions from "../flux/Actions";
import Store from "../flux/Store";
import PersonalInfoStore from "../flux/PersonalInfoStore";
import OnlinePurchaseStore from "../flux/OnlinePurchaseStore";
import FormGroup from "../components/FormGroup";
import AppStore from "../flux/AppStore";
import Constants from '../flux/Constants';
import AppActions from '../flux/AppActions';
import FloatingCustomProductHash from '../components/FloatingCustomProductHash';
import LanguageStore from '../flux/LanguageStore';
import CountryStore from '../flux/CountryStore';
import CountriesStore from '../flux/CountriesStore';
import dispatchDataLayerEvent, { eventTypes } from '../utils/dispatchDataLayerEvent';

class BookAppointment extends Component {
  // @todo 2017-09-29 Refactor with new Store
  subscriptions = [];
  constructor(props) {
    super(props);

    // We need to add a minimum time before we hide the loading overlay. We
    // save the timestamp of when the form is submitted here.
    this.submitClickTime = null;
    this.personalInfos = PersonalInfoStore.getState();

    this.initialCustomProduct = AppStore.getCustomProduct();
    this.initialCountry = CountryStore.getState();
    this.countries = CountriesStore.getState();
    this.selectedCountry = this.countries.find((country) => country.id === this.initialCountry);
    this.initialPurchase = this.selectedCountry.online_purchase === 1 ? true : (
                          this.selectedCountry.online_purchase === null &&
                          this.initialCustomProduct.custom_colored &&
                          !this.initialCustomProduct.custom_fitted ? null : false);

    this.initialInputFieldState = {
      'name': '',
      'surname': '',
      'email': this.personalInfos.email,
      'store': '',
      'phone': '',
      'logos_agreement': 0,
      'terms_of_service': this.personalInfos.terms_of_service !== undefined ? this.personalInfos.terms_of_service : 0,
      'newsletter': this.personalInfos.newsletter !== undefined ? this.personalInfos.newsletter : 0,
      'personal_data_agreement': this.personalInfos.personal_data_agreement!== undefined ? this.personalInfos.personal_data_agreement : 0 ,
    };

    this.state = Object.assign({
      oldChangedLanguage: LanguageStore.getState(),
      hsFormAlreadyCreated:false,
      hsOpen : false,
      customProduct: AppStore.getCustomProduct(),
      store: null,
      errors: null,
      online_purchase: this.initialPurchase
    }, this.initialInputFieldState);

    props.navigation.onBack(() => {
      if(this.state.customProduct.custom_colored){
        props.navigation.navigate('configured');
      }else{
        props.navigation.navigate('modelFit');
      }

    });

    this.onBookAppointmentResponse = this.onBookAppointmentResponse.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.onCustomProductUpdate = this.onCustomProductUpdate.bind(this);
    this.onStoreListChange = this.onStoreListChange.bind(this);
  }

  componentDidMount() {
    Store.events.bookAppointment.addListener(this.onBookAppointmentResponse);
    Store.events.getStores.addListener(this.onStoreListChange);
    AppStore.events.updateCustomProduct.addListener(this.onCustomProductUpdate);
    this.subscriptions.push(OnlinePurchaseStore.addListener(() => {
      this.setState({ online_purchase_store: OnlinePurchaseStore.getState() });
    }));

    Actions.getStores();
  }

  componentWillUnmount() {
    Store.events.bookAppointment.removeListener(this.onBookAppointmentResponse);
    Store.events.getStores.removeListener(this.onStoreListChange);
    AppStore.events.updateCustomProduct.removeListener(this.onCustomProductUpdate);
    this.subscriptions.forEach(subscription => subscription.remove());
  }

  onCustomProductUpdate() {
    this.setState({ customProduct: AppStore.getCustomProduct() });
  }

  onStoreListChange() {
    this.setState({ stores: Store.getStores() });
  }

  // https://facebook.github.io/react/docs/forms.html#handling-multiple-inputs
  onInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    const errors = this.state.errors;

    if (errors && errors[name]) {
      delete errors[name];
    }

    this.setState({
      [name]: value,
      errors,
    });
  }

  onAppointmentFormSubmit() {
    this.submitClickTime = +new Date();

    // If we have a customProduct for the appointment, we use it, otherwise
    // we give the API some essential data to create a simple customProduct.
    const customProductData = this.state.customProduct.hash ? {
      custom_product_hash: this.state.customProduct.hash,
      preset_id: this.state.customProduct.color.code,
      perforated: +this.state.customProduct.perforated,
      custom_fitted: +this.state.customProduct.custom_fitted,
      custom_colored: +this.state.customProduct.custom_colored,
      country_id: this.initialCountry,
    } : {
      product_id: this.state.customProduct.product.id,
      preset: this.state.customProduct.color.name, // here for backwards compatibility.
      preset_id: this.state.customProduct.color.code,
      perforated: +this.state.customProduct.perforated,
      custom_fitted: +this.state.customProduct.custom_fitted,
      custom_colored: +this.state.customProduct.custom_colored,
      country_id: this.initialCountry,
    };

    // Merge the appointment data and the custom product data to book a new
    // appointment.
    Actions.bookAppointment({
      ...{
        name: this.state.name,
        surname: this.state.surname,
        email: this.state.email,
        store: this.state.store,
        phone: this.state.phone,
        terms_of_service: +this.state.terms_of_service,
        newsletter: +this.state.newsletter,
        personal_data_agreement: +this.state.personal_data_agreement,
        size_type: this.state.customProduct.sizeType,
        online_purchase: this.state.online_purchase === true ? 1 : 0,
        logos_agreement: this.state.logos_agreement,
        status: 'ready_to_purchase',
        language: LanguageStore.getState()
      },
      ...customProductData,
    });

    AppActions.setOnlinePurchase(this.state.online_purchase);

    const event = this.state.online_purchase === true
      ? eventTypes.BUY_ONLINE_SUBMIT
      : eventTypes.BOOK_APPOINTMENT_SUBMIT;

    dispatchDataLayerEvent({
      event,
      user_type: window.USER_TYPE,
    });
  }

  onBookAppointmentResponse(data, error) {
    // We wrap the behaviour of this function in a anonymous function to control
    // when it's executed. See below: we need to assure at least two seconds
    // have passed after the submit is clicked.
    const next = () => {
      if (error && error.response && error.response.status === 422) {
        error.response.json().then(response => {
          this.setState({ errors: response.errors });
          AppActions.hideLoadingScreenOverlay();
        });
      } else if (error) {
        // Handle generic error
        console.error(error);
        AppActions.hideLoadingScreenOverlay();
      } else {
        this.setState(this.initialInputFieldState, () => {
          // We show the user a static thank you page.
          AppActions.hideLoadingScreenOverlay();
          this.props.navigation.navigate('thankYou');
        });
      }
    };

    const timeElapsedSinceSubmit = +new Date() - this.submitClickTime;
    const minimumTimeToElapse = 2 * 1000;

    if (timeElapsedSinceSubmit > minimumTimeToElapse) {
      next()
    } else {
      setTimeout(next, minimumTimeToElapse - timeElapsedSinceSubmit);
    }
  }

  groupByCountry(stores) {
    const groupBy = (countries, store) => {
      if ( ! countries[store.country]) {
        countries[store.country] = [];
      }

      countries[store.country].push(store);
      return countries;
    };

    return stores.reduce(groupBy, {});
  };

  filterByStoreType(stores) {
    if(this.state.customProduct.custom_fitted === 1 || this.state.customProduct.custom_fitted === true){
      return stores.filter((store) => store.type !== "DESIGN CENTER")
    }else{
      return stores;
    }
  };



  render() {
    if(LanguageStore.getState() !== this.state.oldChangedLanguage){
      document.getElementById("hubspotContainer").innerHTML = "";
      this.setState({hsFormAlreadyCreated : false, oldChangedLanguage: LanguageStore.getState()});
    }

    const storeFormCodes = {
      en: "a5f98102-4a14-49eb-b0e9-a530a8fe5a28",
      it: "d93e6946-5e7f-49ed-8c14-d035392b96c1",
      de: "727d5dfa-38c8-4f78-ae7c-37130d475540",
      fr: "9cbc1382-6163-46db-90a2-35abf83a3782",
      es: "70b6d894-a069-49bb-a6c3-7bce83dab3a3"
    };
    if(this.state.hsFormAlreadyCreated === false){
        window.hbspt.forms.create({
          region: "na1",
          portalId: "3410681",
          formId: storeFormCodes[LanguageStore.getState()],
          target: "#hubspotContainer"
        });
        this.setState({hsFormAlreadyCreated : true});
    }
    return (
      <div>

        <Header
          title={__('Configurator')}
        />

        <FloatingCustomProductHash hash={this.state.customProduct.hash} />

        <Footer
          navigation={this.props.navigation}
          showNextButton={false}
        />

        <StepIndicator currentScreen={this.props.navigation.currentScreen} />

        <div className="main">
          <div id="hubspotContainer" style={{display: this.state.hsOpen ? 'block' : 'none'}}><button id="closeHubspotForm" onClick={() => this.setState({hsOpen: false})}>X</button></div>
          <div className="row">
            <div className="col-xs-8 col-xs-offset-2">
              <div style={{marginBottom: '1rem'}} className="main__hero">
                <h1 className="hero__title">{__('Let\'s get started on your Dainese Custom Works project!')}</h1>
                <div className="hero__text">
                  <p>
                    {__('Fill-in the form below and select if you would like to purchase from one of our Retail Stores, Certified Centers, Design Centers or directly from Dainese (only available for Custom Colour).')}
                  </p>
                </div>
              </div>
              <form className="form-horizontal bookAppointmentForm" onSubmit={e => {
                e.preventDefault();
                this.onAppointmentFormSubmit();
                AppActions.showLoadingScreenOverlay(__('Sending the request to Dainese…'));
              }}>
                <div className="row">
                  <FormGroup name="name" errors={this.state.errors}>
                    <input type="text" name="name" value={this.state.name} className="form-control" placeholder={__('name*')} required onChange={this.onInputChange} />
                  </FormGroup>

                  <FormGroup name="surname" errors={this.state.errors}>
                    <input type="text" name="surname" value={this.state.surname} className="form-control" placeholder={__('surname*')} required onChange={this.onInputChange} />
                  </FormGroup>
                </div>
                <div className="row">
                  <FormGroup name="email" errors={this.state.errors}>
                    <input type="email" name="email" value={this.state.email} className="form-control" placeholder={__('email*')} required onChange={this.onInputChange} />
                  </FormGroup>
                  <FormGroup name="phone" errors={this.state.errors}>
                    <input type="tel" name="phone" value={this.state.phone} className="form-control" placeholder={__('phone*')} required onChange={this.onInputChange} />
                  </FormGroup>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <FormGroup name="terms_of_service" errors={this.state.errors} className="checkbox">
                      <label className="u-fw-600">
                        <input type="checkbox" name="terms_of_service" checked={ !! this.state.terms_of_service} onChange={this.onInputChange} required />
                        <span className="checkbox__trigger" />
                        {__('* By signing this form, you agree that you have read and understood the Dainese S.p.A. Privacy Policy, available at Privacy Policy Dainese, and agree to permit Dainese S.p.A. to collect and use the personal data accordingly.')}
                      </label>
                    </FormGroup>

                    <FormGroup name="newsletter" errors={this.state.errors} className="checkbox">
                      <label className="u-fw-600">
                        <input type="checkbox" name="newsletter" checked={ !! this.state.newsletter} onChange={this.onInputChange} />
                        <span className="checkbox__trigger" />
                        {__('I agree to receive special offers, membership benefits, newsletter and brand communications via email and understand I can unsubscribe any time')}
                      </label>
                    </FormGroup>

                    <FormGroup name="personal_data_agreement" errors={this.state.errors} className="checkbox">
                      <label className="u-fw-600">
                        <input type="checkbox" name="personal_data_agreement" checked={ !! this.state.personal_data_agreement} onChange={this.onInputChange} />
                        <span className="checkbox__trigger" />
                        {__('I consent to provide usage and personal data for a better processing of my interests')}
                      </label>
                    </FormGroup>
                    <span className="form__requiredText">
                      (*) {__('Required')}
                    </span>
                  </div>
                  <div className="col-md-6">
                    <div style={{marginBottom:'1rem'}}>
                      <button style={{
                        display: this.initialPurchase === false || this.selectedCountry.online_purchase === 1 ? 'none' :'inline-block' ,
                        width:'45%', fontSize: '65%', padding:'3%'
                      }}
                        className={"btn btn-primary white "+ (this.state.online_purchase === false ? 'selected': '') }
                          onClick={(e) => {
                          e.preventDefault();
                          this.setState({online_purchase: false })
                        }
                      }>
                          {__('Buy in-store')}
                      </button>
                      <button
                        style={{
                          display: this.initialPurchase !== false ? 'inline-block' :'none',
                          float:this.selectedCountry.online_purchase === 1 ? 'none' : 'right' ,width:this.selectedCountry.online_purchase === 1 ? '100%' : '45%', fontSize: '65%', padding:'3%'
                        }}
                        className={"btn btn-primary white "+ (this.state.online_purchase === true ? 'selected': '') }
                        onClick={(e) => {
                          e.preventDefault();
                          this.setState({online_purchase: true , store: ''});
                        }
                      }>
                          {__('Buy Online')}
                      </button>
                    </div>
                    <div style={{display: this.state.online_purchase === true ? 'block' :'none'}}>
                      <FormGroup name="logos_agreement" errors={this.state.errors} className="checkbox">
                        <label className="u-fw-600">
                          <input type="checkbox" required={this.state.online_purchase === true} name="logos_agreement" checked={ !! this.state.logos_agreement} onChange={this.onInputChange} />
                          <span className="checkbox__trigger" />
                          {__('* I have authorization to use trademarks and images')}
                        </label>
                      </FormGroup>
                    </div>

                    <div style={{display: this.state.online_purchase === false ? 'block' :'none'}}>
                      <FormGroup className={"form-group"} name="store" errors={this.state.errors}>
                        <select name="store" className="form-control" value={this.state.store !== null ? this.state.store : ''} onChange={this.onInputChange}>
                          <option value="">{__('Choose the store…')}</option>
                          {this.state.stores ? ((() => {
                            const stores = this.state.stores.sort((a, b) => {
                              if (a.name < b.name) return -1;
                              if (a.name > b.name) return 1;
                              return 0;
                            });

                            const countries = this.groupByCountry(this.filterByStoreType(stores));

                            return Object.keys(countries).sort((a, b) => {
                              if (a < b) return -1;
                              if (a > b) return 1;
                              return 0;
                            }).map(country => (
                              <optgroup key={country} label={country}>
                                {countries[country].map(store => (
                                  <option key={store.id} value={store.id}>{store.name}</option>
                                ))}
                              </optgroup>
                            ))
                          })()) : (
                            <option value={null}>{__('Loading…')}</option>
                          )}
                        </select>
                      </FormGroup>
                      <button className="boxHS" onClick={(e) => {
                        e.preventDefault();
                        this.setState({hsOpen: true});
                      }}>{__('Cannot find a store near you? CLICK HERE')}</button>
                    </div>
                  </div>
                </div>
                <div className="u-ta-center u-mt-40">
                  <button className="btn btn-primary btn-lg" disabled={this.state.online_purchase === null}>
                    {__('Proceed')}
                  </button>
                  {this.state.online_purchase !== null && (this.state.online_purchase === true ? (
                      <div className="buy__explanation">{__('A member of the Dainese Custom Works will be contacting you')}</div>
                    ) : (
                      <div className="buy__explanation">{__('A message will be sent to the store and you will be contacted')}</div>
                    ) )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BookAppointment;



// WEBPACK FOOTER //
// ./src/screens/BookAppointment.js